import React from 'react';
import Style from './OnPauseAccount.module.scss';

const OnPauseAccount = () => {
  const { subscriptionPauseMessage, subscriptionPauseCTA } = window.Language;
  const { myAccountUrl } = window.ExternalConfig;
  return (
    <div className={Style.container}>
      <p className={Style.message}>{subscriptionPauseMessage}</p>
      <a href={myAccountUrl} className={Style.button}>
        {subscriptionPauseCTA}
      </a>
    </div>
  );
};

export default OnPauseAccount;
